module.exports = __webpack_public_path__ + "img/colored-square.1d9137f3.svg";